<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 哮天系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>辅助平台</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-input v-model="query.name" placeholder="请输入平台名称" class="handle-input mr10"></el-input>
				<el-select v-model="query.platformType" placeholder="请选择平台类型" filterable>
					<el-option key="" label="请选择平台类型" value=""></el-option>
					<el-option key="0" label="搜索引擎" value="0"></el-option>
					<el-option key="1" label="B2B平台" value="1"></el-option>
					<el-option key="2" label="企业信息平台" value="2"></el-option>
					<el-option key="3" label="AI平台" value="3"></el-option>
					<el-option key="4" label="地图平台" value="4"></el-option>
					<el-option key="5" label="企业官网" value="5"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态" filterable>
					<el-option key="" label="请选择平台类型" value=""></el-option>
					<el-option v-for="item in statusKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="name" label="平台名称"></el-table-column>
				<el-table-column prop="platformType" label="平台类型" :formatter="platformTypeFormatter">
				</el-table-column>
				<el-table-column prop="host" label="域名"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
				<el-table-column prop="createTime" label="状态" width="180">
					<template slot-scope="scope">
                        {{scope.row.status=="0"?"已激活":"未激活"}}
                    </template>
				</el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="50%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-tabs v-model="activeName" type="card">
					<el-tab-pane label="基本信息" name="baseTab">
						<el-row>
							<el-col :span="12">
								<el-form-item label="平台名称" prop="name">
									<el-input type=input v-model="form.name"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="需要登录" prop="needLogin">
									<el-switch v-model="form.needLogin"></el-switch>
								</el-form-item>
							</el-col>
							<el-col :span="7">
								<el-form-item label="状态" prop="needLogin">
									<el-select v-model="form.status" placeholder="请选择状态" filterable>
										<el-option key="" label="请选择状态" value=""></el-option>
										<el-option v-for="item in statusKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="平台类型" prop="platformType">
									<el-select v-model="form.platformType" placeholder="请选择平台类型" filterable>
										<el-option key="" label="请选择平台类型" value=""></el-option>
										<el-option key="0" label="搜索引擎" :value="0"></el-option>
										<el-option key="1" label="B2B平台" :value="1"></el-option>
										<el-option key="2" label="企业信息平台" :value="2"></el-option>
										<el-option key="3" label="AI平台" :value="3"></el-option>
										<el-option key="4" label="地图平台" :value="4"></el-option>
										<el-option key="5" label="企业官网" :value="5"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="域名" prop="host">
									<el-input type=input v-model="form.host"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="路由前缀" prop="prefix">
									<el-input type=input v-model="form.prefix"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="字符集" prop="charSet">
									<el-input type=input v-model="form.charSet"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-form-item label="Cookie" prop="cookie">
							<el-input type=textarea :rows=5 v-model="form.cookie"></el-input>
						</el-form-item>
						<el-form-item label="头信息" prop="header">
							<el-input type=textarea :rows=5 v-model="form.header"></el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="登录步骤" name="loginTab">
						<el-input type=textarea :rows=20 v-model="form.loginStep"> </el-input>
					</el-tab-pane>
					<el-tab-pane label="采集列表步骤" name="publishTab">
						<el-input type=textarea :rows=20 v-model="form.listStep"> </el-input>
					</el-tab-pane>
					<el-tab-pane label="采集详情步骤" name="detailTab">
						<el-input type=textarea :rows=20 v-model="form.detailStep"> </el-input>
					</el-tab-pane>
					<el-tab-pane label="列表正则" name="listRuleTab">
						<el-input type=textarea :rows=20 v-model="form.listRule"> </el-input>
					</el-tab-pane>
					<el-tab-pane label="详情正则" name="ruleTab">
						<el-input type=textarea :rows=20 v-model="form.rule"> </el-input>
					</el-tab-pane>
					<el-tab-pane label="过滤配置" name="filterTab">
						<el-input type=textarea :rows=20 v-model="form.filter"> </el-input>
					</el-tab-pane>
				</el-tabs>
			</el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { fetchPotentialResourcesPlatformData, savePotentialResourcesPlatform, deletePotentialResourcesPlatform, getPotentialResourcesPlatform} from '../../../api/index';
export default {
    name: 'potential-resources-platform',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			enumKV:[],
			title:"",
			activeName:"baseTab",
			rules: {
                name: [{ required: true, message:'请输入规则名称', trigger: 'blur' }],
                platformType: [{ required: true, message: '请选择平台类型', trigger: 'blur' }],
				host: [{ required: true, message: '请输入域名', trigger: 'blur' }]
            },
			platformTypeMapping:{"0":"搜索引擎","1":"B2B平台","2":"企业信息平台","3":"AI平台","4":"地图平台","5":"企业官网"},
			statusKV:[{"key":0,"value":"已激活"},{"key":1,"value":"未激活"}]
        };
    },
    created() {
        this.getData();
    },
    methods: {
        // 获取分页数据
        getData() {
            fetchPotentialResourcesPlatformData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		platformTypeFormatter(row, column, cellValue){
			return this.platformTypeMapping[cellValue];
		},
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deletePotentialResourcesPlatform([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.activeName="baseTab";
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
			this.activeName="baseTab";
            //this.form = row;
			this.title = "编辑";
			getPotentialResourcesPlatform(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					savePotentialResourcesPlatform(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							//this.$message.success(`修改第 ${this.idx + 1} 行成功`);
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
